import React, { useEffect, useState } from 'react';
import moment from 'moment';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../../images/icons/upload_new.svg';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
import {
  incomeDocUpload,
  UploadFileToS3,
  incomeDocUploaded
} from '../../../../common/constants/api';
import PopUp from '../../../../common/components/PopUp/PopUp';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';

import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';

const Form16MultiParts = ({
  form16Result,
  setF16MinUploaded,
  data,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  validateForm
}) => {
  const [editFf16A, setEditFf16A] = useState(false);
  const [editFf16B, setEditFf16B] = useState(false);
  const [editSf16A, setEditSf16A] = useState(false);
  const [editSf16B, setEditSf16B] = useState(false);
  const [loader, setLoader] = useState(false);
  const [popUpDeatils, setPopUpDetails] = useState({
    text: 'Uploading Documents Please Wait...!',
    type: 'loading'
  });
  const [leadAppicantId, setLeadApplicantId] = useState(
    getApplicantionInfo()?.leadApplicantId
  );
  const [leadId, setLeadId] = useState(getApplicantionInfo()?.leadId);


  let years = ['previous', 'lastPrevious'];
  let form16_part_list = ['A', 'B'];

  const getIndex = (parent, child) => {
    if (parent == 'A' && child == 'previous') return 5;
    else if (parent == 'A' && child == 'lastPrevious') return 6;
    else if (parent == 'B' && child == 'previous') return 7;
    else if (parent == 'B' && child == 'lastPrevious') return 8;
    else return false;
  };

  const getEditStatus = (parent, child) => {
    if (parent == 'A' && child == 'previous') return editFf16A;
    else if (parent == 'A' && child == 'lastPrevious') return editSf16A;
    else if (parent == 'B' && child == 'previous') return editFf16B;
    else if (parent == 'B' && child == 'lastPrevious') return editSf16B;
    else return false;
  };
  const setEditStatus = (parent, child) => {
    if (parent == 'A' && child == 'previous') return setEditFf16A;
    else if (parent == 'A' && child == 'lastPrevious') return setEditSf16A;
    else if (parent == 'B' && child == 'previous') return setEditFf16B;
    else if (parent == 'B' && child == 'lastPrevious') return setEditSf16B;
    else return false;
  };

  const getYear = child => {
    if (child == 'previous')
      return moment()
        .subtract(1, 'years')
        .format('YYYY');
    if (child == 'lastPrevious')
      return moment()
        .subtract(2, 'years')
        .format('YYYY');
  };

  const uploadDocument = async (index, tag) => {
    setLoader(true);
    return await incomeDocUpload(
      data.file?.[index]?.[0],
      leadId,
      leadAppicantId,
      'form16',
      tag
    );
  };

  const setUploadedStatus = async docId => {
    return await incomeDocUploaded(leadId, leadAppicantId, docId, 'form16');
  };
  const handleUpload = async (index, tag) => {
    setLoader(true);
    try {
      uploadDocument(index, tag).then(async uploadResult => {
        await UploadFileToS3(uploadResult?.url, data.file?.[index]?.[0]);
        await setUploadedStatus(uploadResult?.requestId);
        setPopUpDetails({
          type: 'success',
          text: 'File Uploaded Successfully!'
        });
        setTimeout(() => {
          setLoader(false);
          setF16MinUploaded(true);
        }, 2000);
      });
    } catch {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!data?.file?.[5] || !data?.file?.[5]?.[0]) return;
    handleUpload(5, 'previousYearTypeA');
  }, [data?.file?.[5]]);

  useEffect(() => {
    if (!data?.file?.[6] || !data?.file?.[6]?.[0]) return;
    handleUpload(6, 'lastPreviousYearTypeA');
  }, [data?.file?.[6]]);

  useEffect(() => {
    if (!data?.file?.[7] || !data?.file?.[7]?.[0]) return;
    handleUpload(7, 'previousYearTypeB');
  }, [data?.file?.[7]]);

  useEffect(() => {
    if (!data?.file?.[8] || !data?.file?.[8]?.[0]) return;
    handleUpload(8, 'lastpreviousYearTypeB');
  }, [data?.file?.[8]]);

  const getImgUrlUsingTag = (parent, child) => {
    let tag = '';
    if (typeof form16Result?.links !== 'object') return null;
    if (parent == 'A' && child == 'previous') tag = 'previousYearTypeA';
    else if (parent == 'A' && child == 'lastPrevious')
      tag = 'lastPreviousYearTypeA';
    else if (parent == 'B' && child == 'previous') tag = 'previousYearTypeB';
    else if (parent == 'B' && child == 'lastPrevious')
      tag = 'lastpreviousYearTypeB';
    let reqDocUrl = form16Result?.links?.find(each => each?.tag == tag);
    return reqDocUrl?.url;
  };
  return (
    <div classNam="w-full ">
      {form16_part_list.map((part_list, index) => (
        <div className="w-full">
          <p className="font-roboto text-sm text-black-1002 mt-3">
            Part {part_list}
          </p>
          <div className="w-full flex flex-wrap justify-evenly gap-0.5">
            {years.map((year, i) => (
              <div className="">
                {getImgUrlUsingTag(part_list, year) &&
                !getEditStatus(part_list, year) ? (
                  <div className="ml-2 mt-4">
                    <ShowGetImage
                      img={getImgUrlUsingTag(part_list, year)}
                      setEdit={setEditStatus(part_list, year)}
                    />
                  </div>
                ) : (
                  <>
                    <p className="font-roboto font-normal text-grey-50 text-left ml-5 md:text-center md:ml-0 mb-2 md:mb-0 ">
                      {getYear(year)}
                    </p>

                    <GlobalUploadComp
                      data={data}
                      imgIndex={getIndex(part_list, year)} //0,1,2,3 depending upon the no of file sequence
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      // showFullImage={showFullImage} // boolean , to change mobile upload image view
                      initialImg={initialImg} // initial image
                      subInst="Click here to upload"
                      subtext="CHOOSE FRONT VIEW"
                    />
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
      <PopUp
        type={popUpDeatils?.type}
        text={popUpDeatils?.text}
        setShow={setLoader}
        show={loader}
      />
    </div>
  );
};

export default withErrorHandler(Form16MultiParts);
